/* FILE: ./frontend/src/hooks/useVisitorTracking.jsx */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function useVisitorTracking() {
    const location = useLocation();

    useEffect(() => {
        const trackVisitor = async () => {
            // 1. Ignore admin routes
            if (location.pathname.startsWith('/admin')) return;

            // 2. Anonymous Device Identification
            let visitorId = localStorage.getItem('tb_visitor_id');
            if (!visitorId) {
                visitorId = crypto.randomUUID();
                localStorage.setItem('tb_visitor_id', visitorId);
            }

            // 3. Authenticated User Identification
            // Pulls identity automatically if the user is logged into Supabase
            const { data: { session } } = await supabase.auth.getSession();
            const userEmail = session?.user?.email || null;

            // 4. Geolocation Resolution from Vercel Headers
            let geoData = { city: null, province: null, country: null };
            try {
                const geoRes = await fetch('/api/geo');
                if (geoRes.ok) {
                    const data = await geoRes.json();
                    geoData = {
                        city: data.city !== 'Unknown' ? data.city : null,
                        province: data.province !== 'Unknown' ? data.province : null,
                        country: data.country !== 'Unknown' ? data.country : null
                    };
                }
            } catch (err) {
                // Silently fails on network error or adblockers
            }

            // 5. Database Insertion
            await supabase.from('page_views').insert([{
                path: location.pathname,
                visitor_id: visitorId,
                user_email: userEmail,
                city: geoData.city,
                province: geoData.province,
                country: geoData.country
            }]);
        };

        trackVisitor().catch(() => {});

    }, [location.pathname]);
}